


















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { store, StoreState } from "../../store";
import { mapState } from "vuex";
import * as moment from 'moment'; 
import util from '../../lib/util';
import VueElementLoading from 'vue-element-loading';
    @Component({
        components: {
            VueElementLoading
        },
        computed: {    
            ...mapState({
                alert_loader: (state: StoreState) => state.dashboard.admin.admin_loader,
                'notifications': (state: StoreState) => state.dashboard.notifications,
                'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
                'contacts': (state: StoreState) =>state.dashboard.contacts,
                'ringtone': (state: StoreState) =>  state.dashboard.notifiaction_ringtone,
                'incoming_text': (state: StoreState) => state.dashboard.incoming_text,
                'readnotifactionfrom_badge': (state: StoreState) =>state.dashboard.readnotifactionfrom_badge,
                 'readnotifactionfrom_notifModal': (state: StoreState) =>state.dashboard.readnotifactionfrom_notifModal              
    })
    },
    methods: {},
    mounted: function() {
        //console.log("notifications list",(this as any).notifications);
        this.$store.commit('SET_TEXTPNL_CONTACTINFO','')               
        this.$store.commit('SET_START_NEWTEXT',false)
        this.$store.commit('CHANGE_SELECTED_CONTACT', null);
        this.$data.notinction_loader=true        
        this.$data.is_textmsgs = true;
        this.$root.$on('highlight_name', (data) => {
         this.$data.fullname=`${(this as any).selectedContact.first_name} ${(this as any).selectedContact.last_name}`;
        })
        setTimeout(
        
        function () {
      this.$data.is_textmsgs= false;
        }.bind(this),
        1000
      );
        },
    })
	export default class TextMessages extends Vue {
        data() {
            return {
                msgtab:'textmsg',
                is_textmessages:false,
                notificationmsgs:[],
                 search: '',
                 fullname:'',
                 is_textmsgs:false,
                 start_date: null,
		         end_date: null,
            }
        }

   @Watch('selectedContact')
   selcin(){
     if((this as any).selectedContact==null){
               this.$data.fullname="";
        } ;
   }
 
 @Watch('readnotifactionfrom_badge')
   open_textchain(){
    if((this as any).readnotifactionfrom_badge){
            let alerttext = (this as any).incoming_text;
             this.readNotification(alerttext);
        }
   }
   @Watch('readnotifactionfrom_notifModal')
   open_textchain_frommodal(){
        if((this as any).readnotifactionfrom_notifModal){
            let ntf = (this as any).readnotifactionfrom_notifModal;
             this.readNotification(ntf);
        }
   }

   search_notification()
    {
        this.getnotification_message();
    }

   start_newtext(){    
       this.$store.commit('SET_START_NEWTEXT',true);
       this.$store.commit('CHANGE_SELECTED_CONTACT', null);
       this.$store.commit('SET_TEXTPNL_CONTACTINFO','Message_list');
       this.$store.dispatch("cancel_axios_request");
   }
   
    readNotification(notification)
    { //console.log('here this');
    this.$store.commit('SET_NOTIFICATION_BADGE' ,false);    
    if(notification.contact) {
        if ( !notification.contact.numbers)
        {
        notification.contact.numbers = {
            mobile: { number: notification.contact.first_name
                },
            main:[notification.contact.first_name]
        }
        notification.contact.address= {};
        notification.name=  notification.contact.first_name;
        notification.contact.hideEdit=true;
       }
       this.$store.commit('SET_START_NEWTEXT',false);
       this.$store.commit('SET_TEXTPNL_CONTACTINFO','Message_list');
       
        this.$store.commit('CHANGE_SELECTED_CONTACT', notification.contact);
            this.$data.fullname=`${(this as any).selectedContact.first_name} ${(this as any).selectedContact.last_name}`;
            this.$emit('notification', notification.socketRoom); 
            this.$store.commit("SHOW_CONTACT_DETAIL", true);
            if (notification.eventType=='vm')
            {
            this.$store.commit("SET_CONTACT_STATUS_VM", true);
            this.$store.commit("SET_NOTIFICATION_VM_ID", notification.id);
            this.$store.commit("SET_NOTIFICATION_VOICE", notification);
            }
            else{
            this.$store.commit('SET_FOCUSTEXT', notification.timetofocus_ontext);
            this.$store.dispatch('markNotificationAsRead', notification);
            this.$store.commit('DELETE_NOTIFICATION', {notificationId: notification.id});
            }
        this.$store.commit('SET_NUMBER_BEING_CALLED', notification.socketRoom);
        this.$data.notifications_open = true;
        let conta = JSON.stringify(notification.contact);           
        this.$store.commit("CHANGE_NOTIFICATION_CONTACT", conta);
        this.$store.commit("SET_TEXTMESSAGETAB",this.$data.activetab);
        }
	}
        
     formatPhoneNumber(obj: any) {
         var phoneNumber= `${obj.first_name} ${obj.last_name}`;
			
		if(obj.contact_status=="new_contact"){
		 return util.formatPhoneNumber(phoneNumber);
		}
		else {
			return `${obj.first_name} ${obj.last_name}`;
		}
        //return util.formatPhoneNumber(phoneNumber);
    }
    
    unreadmes(nt){
         let unread = nt.filter(function(e){return !e.read});  
        return unread.length;
    }

    getnotification_message(){
           let contact_Messages = (this as any).notifications.filter(function(e){return e.eventType!="vm"});          
         if(this.$data.search!=''){
               let fullNames = contact_Messages.filter(obj => {
                   //search by text history
                   if(obj.tooltip.toLowerCase().includes(this.$data.search.toLowerCase())){
                        return obj.tooltip.toLowerCase().includes(this.$data.search.toLowerCase());
                   }
                   //search by name of contact
                   else{
                         return obj.displayName.toLowerCase().includes(this.$data.search.toLowerCase());
                   }
            });
            contact_Messages=fullNames;
         }     
         
         let group = contact_Messages.reduce((r, a) => {
             /*console.log('a.DisplayName',a.DisplayName);
             console.log('rrr',r);
             console.log('aaa',a);*/
            r[a.displayName] = [...r[a.displayName] || [], a];
            return r;
        }, {});
         const entries = Object.entries(group);
           console.log('entriess',entries);
          return entries; 
    }     


	}
